var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import { beginPush } from 'app/actions/sandboxItemActions';
import { closeModal } from '../../actions/modalActions';
var SandboxPushToAura = /** @class */ (function (_super) {
    __extends(SandboxPushToAura, _super);
    function SandboxPushToAura(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            auraUri: '',
            password: '',
            username: 'neo4j'
        };
        _this.handlePush = _this.handlePush.bind(_this);
        return _this;
    }
    SandboxPushToAura.prototype.componentDidMount = function () {
        var sandboxData = this.props.sandboxData;
        window.neo4jSandbox.analytics.lastInvitePopup = {
            seenAt: Date.now(),
            usecase: sandboxData.usecase,
        };
    };
    SandboxPushToAura.prototype.handlePush = function () {
        var _a = this.state, auraUri = _a.auraUri, username = _a.username, password = _a.password;
        var _b = this.props, sandboxHashKey = _b.sandboxData.sandboxHashKey, accessToken = _b.user.accessToken, onPushConfirm = _b.onPushConfirm, onCloseModal = _b.onCloseModal;
        this.setState({ error: '' });
        var _c = this.allowPush(), error = _c[0], shouldAllowInvite = _c[1];
        if (!shouldAllowInvite) {
            this.setState({ error: error });
            return;
        }
        var params = { auraUri: auraUri, username: username, password: password, sandboxHashKey: sandboxHashKey };
        onPushConfirm(accessToken, params);
        onCloseModal();
    };
    SandboxPushToAura.prototype.allowPush = function () {
        var error = null;
        var _a = this.state, auraUri = _a.auraUri, username = _a.username, password = _a.password;
        if (!auraUri.startsWith('neo4j+s://'))
            error = 'Please enter a valid Aura URI, starting with neo4j+s://';
        if (!error) {
            if (username === '')
                error = 'Username field cannot be empty';
        }
        if (!error) {
            if (password === '')
                error = 'Password field cannot be empty';
        }
        return [error, !error];
    };
    SandboxPushToAura.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, onClose = _a.onClose;
        var _b = this.state, error = _b.error, username = _b.username;
        return (React.createElement(Modal, { open: open, onClose: onClose, size: "tiny", closeIcon: true },
            React.createElement(Modal.Header, null, "Push to Aura"),
            React.createElement(Modal.Content, { scrolling: true },
                React.createElement(Form, null,
                    React.createElement(Form.Field, null,
                        React.createElement("label", null, "Aura URI *"),
                        React.createElement(Form.Input, { type: "text", onChange: function (e, _a) {
                                var value = _a.value;
                                return _this.setState({ auraUri: value });
                            } })),
                    React.createElement(Form.Field, null,
                        React.createElement("label", null, "Username *"),
                        React.createElement(Form.Input, { type: "text", value: username, onChange: function (e, _a) {
                                var value = _a.value;
                                return _this.setState({ username: value });
                            } })),
                    React.createElement(Form.Field, null,
                        React.createElement("label", null, "Password *"),
                        React.createElement(Form.Input, { type: "password", onChange: function (e, _a) {
                                var value = _a.value;
                                return _this.setState({ password: value });
                            } }),
                        error && React.createElement("div", { className: "error mb2 color-danger" }, error)),
                    React.createElement(Form.Field, null,
                        React.createElement(Button, { color: "blue", size: "small", onClick: this.handlePush }, "Push"))))));
    };
    return SandboxPushToAura;
}(Component));
var mapDispatchToProps = function (dispatch) { return ({
    onPushConfirm: function (accessToken, params) { return dispatch(beginPush(accessToken, params)); },
    onCloseModal: function () { return dispatch(closeModal()); },
}); };
var mapStateToProps = function (state) { return ({
    sandboxData: state.activeModal.data,
    user: state.user,
    sandbox: state.sandbox,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxPushToAura);
